import { useEffect } from 'react'

import { Global } from '@emotion/react'
import { Flex } from '@twistopayments/design-system/components/atoms/flex'
import { Logo } from '@twistopayments/design-system/components/atoms/logo'
import { useAtom } from 'jotai'
import Link from 'next/link'

import type { LinkUrl, Navigation as NavigationType } from '@twisto/api-cms'
import { useScrollPosition } from '@twisto/hooks'

import { getLinkUrl } from 'homepage/utils'

import { navigationThemeAtom } from './navigation-theme'
import * as styles from './navigation.styles'
import { PrimaryNavigationSlot } from './primary'
import SecondaryNavigationSlot from './secondary/secondary-navigation-slot'

export const Navigation = ({
  primary,
  secondary,
  authentication,
  type,
  homeLink,
  theme,
}: NavigationType) => {
  const isScrolled = useScrollPosition() !== 0

  const [navigationTheme, setNavigationTheme] = useAtom(navigationThemeAtom)

  useEffect(() => {
    setNavigationTheme(theme ?? 'light')
  }, [theme, setNavigationTheme])

  return (
    <header
      css={[
        styles.header,
        isScrolled && styles.headerScrolled,
        theme ? styles[theme] : styles.light,
      ]}
    >
      <Global styles={styles.globalNavigationStyles} />
      <nav css={styles.navigation}>
        <Flex alignItems="center" css={styles.primaryContainer} wrap="noWrap">
          <Link href={getLinkUrl(homeLink as LinkUrl) || '/'}>
            <Logo
              inverse={navigationTheme === 'dark'}
              logo={type}
              variant="full"
            />
          </Link>

          <PrimaryNavigationSlot primaryNavigationContent={primary} />
        </Flex>

        <SecondaryNavigationSlot
          authenticationNavigationContent={authentication}
          primaryNavigationContent={primary}
          secondaryNavigationContent={secondary}
        />
      </nav>
    </header>
  )
}
